import { useCallback, useMemo } from 'react';
import { useClientStore } from './ClientState';
import { useShallow } from 'zustand/react/shallow';

// Custom hook to manage canvas state and operations
export function useCanvas(debug?: boolean) {
  const datasets = useClientStore(useShallow(state => state.datasets));
  const datasetCount = Object.keys(datasets).length;
  const canvasDisplay = useClientStore(state => state.canvasDisplay);
  const setCanvasDisplay = useClientStore(state => state.setCanvasDisplay);

  // Calculate total available canvas count
  const canvasCount = useMemo(() => {
    let count = datasetCount;
    // Count debug view if available
    if (debug) {
      count++;
    }
    return count;
  }, [debug, datasetCount]);

  // Check if canvas is currently open
  const canvasOpen = canvasDisplay !== null;

  // Function to handle opening the canvas
  const handleOpenCanvas = useCallback(() => {
    if (canvasCount > 0) {
      // Open canvas with default view - let CanvasView handle which tab is selected
      if (debug) {
        setCanvasDisplay({ type: 'debug' });
      } else {
        const firstDatasetName = Object.keys(datasets)[0];
        if (firstDatasetName) {
          setCanvasDisplay({ type: 'dataset', name: firstDatasetName });
        }
      }
    }
  }, [canvasCount, debug, datasets, setCanvasDisplay]);

  return {
    canvasCount,
    canvasOpen,
    handleOpenCanvas
  };
}
